<ion-grid class="ion-no-padding">
  @if (!disabled) {
    <ion-row>
      <ion-col class="search-bar-container ion-no-padding">
        <ion-searchbar
          class="ion-no-padding with-border"
          type="text"
          debounce="500"
          show-clear-button="always"
          placeholder="Search for a user"
          [(ngModel)]="searchInput"
          (ionInput)="searchInputChanged($event)"
        (ionClear)="clearSearch()"></ion-searchbar>
        <ion-list class="container-shadow search-result-list">
          @for (result of searchResults; track result.id) {
            @if (isUser(result)) {
              <rc-user-search-result
                [user]="result"
              (onClick)="selectSearchResult($event)"></rc-user-search-result>
            }
            @if (!isUser(result)) {
              <rc-driver-search-result
                [driver]="result"
              (onClick)="selectSearchResult($event)"></rc-driver-search-result>
            }
          }
          @if (isSearching) {
            <ion-item>
              <ion-spinner name="crescent"></ion-spinner>
              <ion-label class="ion-margin-start">Searching...</ion-label>
            </ion-item>
          }
          @if (!isSearching && !!searchInput && searchResults.length === 0) {
            <ion-item>No results</ion-item>
          }
        </ion-list>
      </ion-col>
    </ion-row>
  }

  <ion-row>
    <ion-col class="address ion-no-padding">
      <div class="clickable" (click)="onValueClick.emit()">
        <ion-item
          class="value"
          [disabled]="disabled"
          [lines]="disabled ? 'none' : 'full'"
          color="white"
          [ngClass]="baseCssClass">
          <ion-icon slot="start" name="person-outline"></ion-icon>
          <ion-text>{{ readOnlyValue }}</ion-text>
        </ion-item>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
